import { useContext, useState } from "react";
import { Alert, Box, Button, FormControl, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField, Typography } from "@mui/material"
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { loginAdmin, loginUser } from "../axios/axiosFunctions";
import { UserContext } from "../contexts/user";
import { Link, useLocation, useNavigate } from "react-router-dom";

const defaultLoginForm = {
    email : "",
    password : "",
}

const LoginForm = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const {setCurrentUser}  = useContext(UserContext);
    const [loginForm, setLoginForm] = useState(defaultLoginForm);
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const [showError, setShowError] = useState(false);
    const {email,password} = loginForm;

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleLoginChange = (e)=>{
        const {name,value} = e.target;
        setLoginForm({...loginForm,[name]:value});
    };

    const handleLoginSubmit = async(e)=>{
        e.preventDefault();
        const data = {
            email,
            password
        };

        let logInfo;
        if(location.pathname === "/admin"){
            logInfo = await loginAdmin(data);  
        }else{
            logInfo = await loginUser(data);  
        }
        const {user,msg} = logInfo;

        if(!user){
            setError(msg);
            setShowError(true);
            setTimeout(() => {
              setShowError(false);
            }, 4000);
            return;
        }

        setLoginForm(defaultLoginForm);
        setCurrentUser(user);
        localStorage.setItem('userK2G',JSON.stringify(user));

        if(user.rol === "user" && user.firstTime){
           navigate('/create_profile');
           return;
        }
        navigate('/');
        return;
    }

    return (
    <Box sx={{margin:"20px 0px"}}>
        <form onSubmit={handleLoginSubmit}>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <TextField required fullWidth onChange={handleLoginChange} name='email' label="Email address" color="primary"/>
                </Grid>
                <Grid size={12}>
                    <FormControl fullWidth variant="outlined">
                    <InputLabel>Password*</InputLabel>
                    <OutlinedInput
                        type={showPassword ? 'text' : 'password'}
                        fullWidth
                        name='password'
                        required
                        onChange={handleLoginChange}
                        endAdornment={
                        <InputAdornment position="end">
                            <IconButton onClick={handleClickShowPassword}>
                            {showPassword ? <VisibilityOff/> : <Visibility/>}
                            </IconButton>
                        </InputAdornment>
                        }
                        label="Password*"
                    />
                    </FormControl>
                </Grid>
            </Grid>
            {location.pathname === "/admin" && (
              <Box sx={{ textAlign: "right", mt: 1 }}>
                <Link to="/admin/forgot-password" style={{ textDecoration: "none" }}>
                  <Typography variant="body2" color="secondary" sx={{ cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>
                    Forgot Password?
                  </Typography>
                </Link>
              </Box>
            )}
            <Button type='submit' sx={{marginTop:{xs:"20px",sm:"50px"}, marginBottom:"10px"}} size="large" fullWidth variant="contained" color="secondary">LOG IN</Button>
            {
              showError &&
              <Alert sx={{marginTop:"20px"}} severity="error">
                {error}
              </Alert>
            }
        </form>
    </Box>
    )
}

export default LoginForm